import { useEffect } from "react";
import { motion } from "framer-motion";
import { pageAnimation } from "../animate";
import ScrollTop from "../components/ScrollTop";
import TypeIt from "typeit";
import Java from "../img/trying.png";
import JavaBoy from "../img/javaDev.png";
import Android from "../img/android.png";
import CourseDetail7 from "../components/CourseDetail7";
import CourseDetail71 from "../components/CourseDetail71";

const JavaCourse = () => {
  useEffect(() => {
    new TypeIt("#element", {
      strings: ["來杯Java吧!  2026 Java 課程"],
      speed: 100,
      afterComplete: (instance) => {
        const el = document.querySelector("#element");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
    }).go();

    new TypeIt("#element2", {
      strings:
        "從入門開始學習Java語法，課程包含Java 8、物件導向程式設計，製作貪食蛇遊戲、出埃及記遊戲、面試題目解題、MySQL資料庫、網頁開發、Stream、多線程Java編寫等等內容，一步一步成為Java大師。",
      speed: 15,
      afterComplete: (instance) => {
        const el = document.querySelector("#element2");
        const cursor = el?.querySelector(".ti-cursor");
        if (cursor) cursor.style.display = "none";
        return instance;
      },
      startDelay: 1500,
      loop: false,
    }).go();
  }, []);

  return (
    <div>
      <motion.div
        variants={pageAnimation}
        initial="hidden"
        animate="show"
        className="webdev"
        exit="exit"
      >
        <div className="img">
          <img src={Java} alt="" />
        </div>
        <div className="desc">
          <h1>
            <span id="element"></span>
          </h1>
          <div className="content">
            <h3 id="element2"></h3>
          </div>
          <div>
            <p>
              課程價格: <span className="hide">新台幣$290</span>
            </p>
            <p>
              優惠代碼(點擊連結即可自動套用優惠碼):
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/java-master-chinese/?couponCode=${process.env.REACT_APP_JAVA_COUPON}`}
                rel="noreferrer"
              >
                <span>{process.env.REACT_APP_JAVA_COUPON}</span>
              </a>
              (只到
              <span style={{ color: "red" }}>{process.env.REACT_APP_DATE}</span>
              之前有效)
            </p>
            <p>
              課程連結:
              <br />
              <a
                target="_blank"
                href={`https://www.udemy.com/course/java-master-chinese/?couponCode=${process.env.REACT_APP_JAVA_COUPON}`}
                rel="noreferrer"
              >
                <span className="hide">
                  https://www.udemy.com/course/java-master-chinese/
                </span>
              </a>
            </p>
          </div>
        </div>
        <CourseDetail71 img={JavaBoy} />
        <CourseDetail7 img={Android} />
        <ScrollTop />
      </motion.div>
    </div>
  );
};

export default JavaCourse;
